import React from "react";
import AddressInline from "../../components/AddressInline";
import {cx} from "../../lib/ClassSet";
import "./AddressWithSelection.css";

const AddressWithSelection = (props) => {

  let fn = () => props.onSelect(props.id);
  let classes = cx({
    "AddressWithSelection": true,
    "u-selected": props.selected
  })
  return (
    <div className={classes} onClick={fn}>
      <div className="radiobox">
        <div className="tick" />
      </div>
      <AddressInline inline={false} address={props.address} />
    </div>
  )

}

export default AddressWithSelection;